import { SimpleGrid, Stack, Text } from "@chakra-ui/react";

import {
  IconAppLp,
  IconBillingLp,
  IconBoostLp,
  IconEnsuranceLp,
  IconInsuranceLp,
  IconLawLp,
  IconRepairsLp,
  IconSignatureLp,
  IconSupportLp,
  IconVirtualLp,
} from "@ud/icons";

const services = [
  {
    icon: <IconBoostLp boxSize="70px" />,
    title: "Zařídíme profesionální inzerci i prohlídky se zájemci",
  },
  {
    icon: <IconEnsuranceLp boxSize="70px" />,
    title: "Zájemce důkladně prověříme v 6 rejstřících",
  },
  {
    icon: <IconSignatureLp boxSize="70px" />,
    title: "Všechny dokumenty podepíšeme elektronicky",
  },
  {
    icon: <IconInsuranceLp boxSize="70px" />,
    title: "Váš majetek chrání pojištění domácnosti a odpovědnosti",
  },
  {
    icon: <IconLawLp boxSize="70px" />,
    title: "Naši právníci jsou odborníci na pronájmy a vymáhání",
  },
  {
    icon: <IconVirtualLp boxSize="70px" />,
    title: "Váš byt pravidelně kontrolujeme a posíláme vám report",
  },
  {
    icon: <IconRepairsLp boxSize="70px" />,
    title: "Zařídíme řemeslníky i opravy a vyřešíme pojistné události",
  },
  {
    icon: <IconAppLp boxSize="70px" />,
    title: "Všechny informace o bytě najdete v klientské zóně",
  },
  {
    icon: <IconBillingLp boxSize="70px" />,
    title: "Vyúčtování energií a služeb za vás spočítají naši odborníci",
  },
  {
    icon: <IconSupportLp boxSize="70px" />,
    title: "Naše klientská podpora je vám k dispozici non-stop",
  },
  {
    icon: <IconInsuranceLp boxSize="70px" />,
    title: "Vyřešíme odchod podnájemníka i předání bytu novému",
  },
  {
    icon: <IconEnsuranceLp boxSize="70px" />,
    title: "O byt pečujeme a vrátíme jej do původního stavu",
  },
];

const ServicesGrid = () => (
  <SimpleGrid maxW="840px" columns={{ base: 2, md: 3, xl: 4 }} gap="30px">
    {services.map((item, index) => (
      <Stack key={index} align="center" spacing="20px" textAlign="center">
        {item.icon}
        <Text>{item.title}</Text>
      </Stack>
    ))}
  </SimpleGrid>
);
export default ServicesGrid;
